import React, { Component } from 'react';

import './breadcrumb.scss';

import { BreadcrumbAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { expression, string, tuple } from '@philips-emr/tws-core/lib/component/prop-types';
import { HistoryService } from '@philips-emr/tws-core/lib/services';
import { listenMatch } from '@philips-emr/tws-core/lib/services/history-service';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { isFunction } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: BreadcrumbAPI })
class Breadcrumb extends Component {

  static propTypes = {
    values: tuple([string, expression]),
  };

  static defaultProps = {
    values: {},
  };

  state = {
    path: '',
    params: {},
    loaded: false,
  };

  componentDidMount() {
    if (!this.state.loaded) {
      const listen = (match = {}) => {
        const { path, params } = match;
        this.setState({ path, params });
      };
      const unlisten = listenMatch(listen);
      this.setState({ loaded: true, unlisten });
      listen(HistoryService.getMatch());
    }
  }

  componentWillUnmount() {
    const { unlisten } = this.state;
    isFunction(unlisten) & unlisten();
  }

  redirect(path) {
    HistoryService.push(path);
  }

  render() {
    const { path = '', params = {} } = this.state;

    let url = '';
    const breadcrumbPieces = path.split('/').map(p => {
      url += `${p}/`;

      const isParam = p[0] === ':';
      const key = isParam ? p.substr(1) : p;

      const piece = this.props.values[key];
      if (piece) {
        const value = params[key];
        return { description: piece, hasValue: !!value, value, url };
      }
      return null;
    });

    const pieces = breadcrumbPieces.filter(p => p !== null);

    return (
      <div className="c-breadcrumb" >
        { pieces.map(p => {
          return (
            <span key={p.description} className="c-breadcrumb-item" >
              <a onClick={() => this.redirect(p.url)} className="c-breadcrumb-item__description" >
                {msg(p.description)}
              </a>
              { p.hasValue ? (
                <span className="c-breadcrumb-item__value" >
                  {p.value}
                </span>
              ) : null }
            </span>
          );}
        )}
      </div>
    );
  }
}

export default Breadcrumb;
